import PropTypes from 'prop-types';
import React from 'react';
import { StyledTabPanel } from './styled-tabs';

const { memo } = React;

const propTypes = {
	activePanel: PropTypes.bool.isRequired,
	children: PropTypes.node.isRequired,
};

function TabPanel({ activePanel, children, ...props }) {
	return (
		<StyledTabPanel hidden={!activePanel} {...props}>
			{children}
		</StyledTabPanel>
	);
}

TabPanel.propTypes = propTypes;

export default memo(TabPanel);
